import { render, staticRenderFns } from "./BarChartPassengers.vue?vue&type=template&id=d4d85062&scoped=true&"
import script from "./BarChartPassengers.vue?vue&type=script&lang=js&"
export * from "./BarChartPassengers.vue?vue&type=script&lang=js&"
import style0 from "./BarChartPassengers.vue?vue&type=style&index=0&id=d4d85062&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d85062",
  null
  
)

export default component.exports